<template>
    <div class='main-container'>
        <h1>Gaming Stats</h1>
        <section class='links-container'>
            <div v-on:click="goToGame('overwatch')" class="each-link overwatch-link">
                <h1>Overwatch</h1>
            </div>
            <div v-on:click="goToGame('apex')" class="each-link apex-link">
                <h1>Apex Legends</h1>
            </div>
            <div v-on:click="goToGame('csgo')" class="each-link csgo-link">
                <h1>CS:GO</h1>
            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Footer from "./Footer";
export default {
  name: "Main",
components: {
    Footer
  },
  data() {
    return {
      platform: "psn",
      gamertag: "",
      game:""
    };
  },
  beforeCreate() {
    // document.body.className = "body-bg-image";
  },
  methods: {
    goToGame(game){
        this.$router.push(`/${game}`);
        this.$router.go();
    }
  }
};
</script>

<style>
    .main-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100vh;
        width: 100vw;
        /* background-image: linear-gradient(to top, rgba(25, 25, 25, 0.6), rgba(99, 99, 99, 0.6)), linear-gradient(to top, rgb(25, 25, 25), rgb(99, 99, 99)); */
        /* background-image: linear-gradient(to bottom right white, rgb(0, 0, 0)); */
        background-image: linear-gradient(to bottom, rgba(132, 169, 253, 0.006), rgba(0, 0, 0, 0.728));
    }

    .main-container > h1 {
        color: rgb(209, 209, 209);
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
        font-weight: bolder;
        font-size: 2.5rem;
        background-color: darkslategray;
        border: 5px solid darkslategray;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        padding:0.1rem 12rem;
    }

    .each-link h1 {
        color: rgba(201, 201, 201, 0.898);
        font-size: 1.8rem;
        padding: 0.6rem 0rem;
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
        font-weight: normal;
    }

    .links-container {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        width: 100%;
        height: 100%;
    }


    .each-link {
        display: flex;
        justify-content: center;
        padding: 1.4rem;
        margin: 2rem;
        cursor: pointer;
        border: 4px solid rgb(66, 66, 66);
        border-radius: 0.3rem;
        background: var(--primary-color) url("./../assets/overwatch/logo.png") no-repeat top center;
        width:25%;
        transition: all .2s ease-in-out;
    }

    .each-link:hover{
        -webkit-transform: scale(1.15);
        -ms-transform: scale(1.15);
        transform: scale(1.15);
    }


    .overwatch-link {
        background: no-repeat top;
        background-size: 140%;
        background-color: #2F4A78;
        background-image: linear-gradient(to right, rgba(47, 74, 120, 0.6), rgba(37, 53, 89, 0.6)), url("./../assets/overwatch/mccree.png"), linear-gradient(to right, #2F4A78, #253559);
    }
    .csgo-link {
        background: no-repeat bottom;
        background-color: rgb(209, 105, 0);
        background-image: linear-gradient(to right, rgba(209, 105, 0, 0.6), rgba(105, 53, 0, 0.6)), url("./../assets/csgo/csgolink.png"), linear-gradient(to right, rgb(209, 105, 0), rgb(105, 53, 0));
        background-position-x: 100%;

    }
    .apex-link {
        background: no-repeat center bottom;
        background-size: 120%;
        background-color: rgb(168, 42, 42);
        background-image: linear-gradient(to right, rgba(168, 42, 42, 0.6), rgba(84, 21, 21, 0.6)), url("./../assets/apex/apexlink.png"), linear-gradient(to right, rgb(168, 42, 42), rgb(84, 21, 21));

    }

    @media(max-width: 450px){
        .links-container {
            flex-direction: column;
            align-items: center;
        }
    }
</style>